

































import {
  computed,
  defineComponent,
  onMounted,
  useRoute,
  watch,
  useStore,
} from '@nuxtjs/composition-api'
import { v4 as guid } from 'uuid'
import BrandMediaSidebarItem from '../UI/BrandMediaSidebarItem.vue'
import { getCodeByRoutePath } from '../utils/getCodeByPath'
import { sidebarItemType } from '@/components/BrandMedia/types/ComponentsTypes'
import BrandMediaLogo from '@/components/BrandMedia/UI/BrandMediaLogo.vue'

import logoPng from '@/assets/images/prostoLogo.png'

import ExpertsIcon from '@/assets/images/experts.png'

export default defineComponent({
  components: { BrandMediaLogo, BrandMediaSidebarItem },
  props: { mainImg: { type: String } },
  setup() {
    const route = useRoute()
    const store = useStore()

    const activeCode = computed(() => store.getters['sections/ACTIVE_CODE'])

    const sidebarItems = computed<{
      main: sidebarItemType | null
      rest: sidebarItemType[]
      all: sidebarItemType[]
    }>(() => {
      const items = store.getters['sections/SIDEBAR_ITEMS']
      const mainIndex = items.findIndex((item) => item.code === 'main')
      const expertsItem: sidebarItemType = {
        id: guid(),
        code: 'expertsrgs',
        dateUpdate: null,
        imgFullUrl: ExpertsIcon,
        link: '/prosto/tags/expertsrgs',
        name: 'Эксперты РГС',
      }
      const all = [...items, expertsItem]
      return {
        main: all[mainIndex] || null,
        rest: all.filter((item) => item.code !== 'main'),
        all,
      }
    })

    const setActiveItem = (item: sidebarItemType) => {
      if (activeCode.value !== item.code) {
        store.dispatch('sections/setActiveCode', item.code)
      }
    }
    const getItemUrl = (item: sidebarItemType) => {
      if (item.code === 'main') {
        return '/prosto'
      }
      return item.link
    }
    watch(
      () => route.value.path,
      (path) => {
        const byItems = getCodeByRoutePath(path, sidebarItems.value.all)
        const fallback = path.split('?')[0].split('/')[2] || 'main'
        const nextCode = byItems || fallback
        if (activeCode.value !== nextCode) {
          store.dispatch('sections/setActiveCode', nextCode)
        }
      },
      { immediate: true }
    )

    const updateActiveSection = async () => {
      const refined = getCodeByRoutePath(
        route.value.path,
        sidebarItems.value.all
      )
      if (refined && refined !== activeCode.value) {
        await store.dispatch('sections/setActiveCode', refined)
      }
    }

    onMounted(updateActiveSection)

    return {
      sidebarItems,
      activeCode,
      setActiveItem,
      getItemUrl,
      logoPng,
    }
  },
})
